/**
 * Simple reducer qui enregistre le type de la dernière action
 */
export default function (state = null, {type}) {
  return type;
}
